import { Container, Link, Stack, Typography } from "@mui/material"
import ContentDialog from "../../../components/Dialogs/ContentDialog"
import React from "react"
import { useTranslation } from "react-i18next"

export interface ITermsPurchaseDialogProps {
  open: boolean
  onClose: () => void
}

const TermsPurchaseDialog = ({ open, onClose }: ITermsPurchaseDialogProps) => {
  const { t } = useTranslation()

  return (
    <ContentDialog
      open={open}
      onClose={onClose}
      title={t("terms.title")}
      hasCancel={false}
      labelPrositive={t("common.ok")}
      maxWidth={"md"}
    >
      <Container>
        <Stack direction="column" spacing={2}>
          <iframe
            src="https://celetus.com/terms/"
            title={t("terms.iframeTitle")}
            height="500"
            frameBorder={"0"}
          />
        </Stack>
      </Container>
    </ContentDialog>
  )
}

export default TermsPurchaseDialog
